import { render, staticRenderFns } from "./PreviewFrame.vue?vue&type=template&id=31cac44a&scoped=true"
import script from "./PreviewFrame.vue?vue&type=script&lang=js"
export * from "./PreviewFrame.vue?vue&type=script&lang=js"
import style0 from "./PreviewFrame.vue?vue&type=style&index=0&id=31cac44a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cac44a",
  null
  
)

export default component.exports